import axios from "./../../config/axios";

function create(data) {
    return axios().post("/fleet/vehicles/usages", data)
}

function get(id) {
    return axios().get(`/fleet/vehicles/usages/${id}`)
}

function update(id, data) {
    return axios().put(`/fleet/vehicles/usages/${id}`, data)
}

function remove(id) {
    return axios().delete(`/fleet/vehicles/usages/${id}`)
}

function list() {
    return axios().get(`/fleet/vehicles/usages`)
}

export default {
    create,
    get,
    update,
    remove,
    list
}